import * as DESCRIPTIONS from '../strings/descriptions'

const Profissionals = {
  SHIFTHOURS: [1, 2, 4, 6, 8, 12],
  SPECIALTIES: {
    CAREGIVERS: {
      title: 'Cuidador de Pessoas',
      id: 1,
      register: null,
      description: DESCRIPTIONS.CAREGIVERS,
      image: 'cuidadores_full.png',
      image_portrait: 'cuidadores_portrait.png',
      image_masked: 'masked_cuidadores.svg',
      hasSubcategories: true,
      textSlide: DESCRIPTIONS.CAREGIVERSTEXTSLIDE,
      url: "/saibamais/cuidadores",
      subcategories: {
        CHILDCARER: {
          id: 1,
          title: 'Cuidador de Crianças'
        },
        ELDERLYCARER: {
          id: 2,
          title: 'Cuidador de Idosos'
        },
        POSTOPERATIVECARER: {
          id: 3,
          title: 'Cuidador Pós-Operatório'
        }
      },
      selectedServices: [],
      services: [
        {
          id: 1,
          title: 'Cuidador de Crianças - Plantão',
          specialityId: 1,
          shift: true,
          description: DESCRIPTIONS.CAREGIVERSHIFT
        },
        {
          id: 2,
          title: 'Cuidador de Idosos - Plantão',
          specialityId: 1,
          shift: true,
          description: DESCRIPTIONS.CAREGIVERSHIFT
        },
        {
          id: 3,
          title: 'Cuidador Pós-Operatório - Plantão',
          specialityId: 1,
          shift: true,
          description: DESCRIPTIONS.CAREGIVERSHIFT
        }
      ]
    },
    NURSES: {
      title: 'Enfermeiros',
      description: DESCRIPTIONS.NURSE,
      image: 'enfermeira_full.png',
      image_portrait: 'enfermeira_portrait.png',
      image_masked: 'masked_enfermagem.svg',
      id: 2,
      register: null,
      register_type: 'Coren',
      hasSubcategories: true,
      textSlide: DESCRIPTIONS.NURSETEXTSLIDE,
      url: "/saibamais/enfermeiros",
      subcategories: {
        NURSE: {
          id: 4,
          title: 'Enfermeiro'
        },
        TECHNICIAN: {
          id: 5,
          title: 'Técnico Enfermagem'
        },
        ASSISTANT: {
          id: 6,
          title: 'Auxiliar de Enfermagem'
        }
      },
      selectedServices: [],
      services: [
        {
          id: 4,
          specialityId: 2,
          title: 'Plantão',
          shift: true,
          selected: false,
          description: DESCRIPTIONS.NURSESHIFT
        },
        {
          id: 5,
          specialityId: 2,
          title:
            'Curativo, Aplicação de Injeções e Administração de Medicamentos',
          shift: false,
          selected: false,
          description:
            DESCRIPTIONS.BANDAGESANDINJECTIONS +
            ' ' +
            DESCRIPTIONS.MEDICATIONADMINISTRATION
        }
      ]
    },
    PHYSIOTHERAPIST: {
      title: 'Fisioterapeutas',
      description: DESCRIPTIONS.PHYSIOTHERAPIST,
      image: 'fisioterapeuta_full.png',
      image_portrait: 'fisioterapeuta_portrait.png',
      image_masked: 'masked_fisio.svg',
      id: 3,
      register: null,
      register_type: 'Crefito',
      hasSubcategories: false,
      selectedServices: [],
      textSlide: DESCRIPTIONS.PHYSIOTHERAPISTTEXTSLIDE,
      url: "/saibamais/fisioterapeutas",
      services: [
        {
          id: 6,
          specialityId: 3,
          title: 'Ortopedia, Traumatologia e Medicina esportiva',
          shift: false,
          selected: false,
          description: DESCRIPTIONS.ORTHOPEDIC
        }
      ]
    },
    MASSAGIST: {
      title: 'Massoterapeutas',
      description: DESCRIPTIONS.MASSAGIST,
      image: 'massagista_full.png',
      image_portrait: 'massagista_portrait.png',
      image_masked: 'masked_massagista.svg',
      id: 4,
      register: null,
      textSlide: DESCRIPTIONS.MASSAGISTTEXTSLIDE,
      url: "/saibamais/massoterapeutas",
      selectedServices: [],
      services: [
        {
          id: 7,
          specialityId: 4,
          title: 'Massagem Clássica / Relaxante',
          shift: false,
          selected: false,
          description: DESCRIPTIONS.CLASSICRELAXINGMASSAGE
        },
        {
          id: 8,
          specialityId: 4,
          title: 'Massagem Modeladora',
          shift: true,
          selected: false,
          description: DESCRIPTIONS.MODELINGMASSAGE
        },
        {
          id: 9,
          specialityId: 4,
          title: 'Drenagem Linfática ',
          shift: false,
          selected: false,
          description: DESCRIPTIONS.LYMPHATICDRAINAGE
        }
      ]
    },
    NUTRITIONIST: {
      title: 'Nutricionistas',
      description: DESCRIPTIONS.NUTRITIONISTS,
      image: 'nutricionista_full.png',
      image_portrait: 'nutricionista_portrait.png',
      image_masked: 'masked_nutrucionista.svg',
      id: 5,
      register: null,
      register_type: 'CRN',
      hasSubcategories: false,
      textSlide: DESCRIPTIONS.NUTRITIONISTTEXTSLIDE,
      url: "/saibamais/nutricionistas",
      selectedServices: [],
      services: [
        {
          id: 10,
          specialityId: 5,
          title: 'Clínica',
          shift: false,
          selected: false,
          description: DESCRIPTIONS.NUTRITIONCLINIC
        },
        {
          id: 11,
          specialityId: 5,
          title: 'Esportiva',
          shift: true,
          selected: false,
          description: DESCRIPTIONS.NUTRITIONSPORT
        },
        {
          id: 12,
          specialityId: 5,
          title: 'Personal Diet',
          shift: false,
          selected: false,
          description: DESCRIPTIONS.PERSONALDIET
        },
        {
          id: 13,
          specialityId: 5,
          title: 'Vegetarianos e Veganos',
          shift: false,
          selected: false,
          description: DESCRIPTIONS.VEGAN
        }
      ]
    },
    PERSONALTRAINER: {
      title: 'Personal Trainers',
      description: DESCRIPTIONS.PERSONALTRAINER,
      image: 'personal_full.png',
      image_portrait: 'personal_portrait.png',
      image_masked: 'masked_personal.svg',
      id: 6,
      register: null,
      register_type: 'Cref',
      hasSubcategories: false,
      textSlide: DESCRIPTIONS.PERSONALTRAINERTEXTSLIDE,
      url: "/saibamais/personaltrainers",
      selectedServices: [],
      services: [
        {
          id: 14,
          specialityId: 6,
          title: 'Treinamento Funcional',
          shift: false,
          selected: false,
          description: DESCRIPTIONS.FUNCTIONALTRAINING
        },
        {
          id: 15,
          specialityId: 6,
          title: 'Condicionamento físico atletas',
          shift: true,
          selected: false,
          description: DESCRIPTIONS.PHYSICALCONDITIONINGATHLETE
        },
        {
          id: 16,
          specialityId: 6,
          title: 'Musculação (iniciante, intermediário e avançado)',
          shift: false,
          selected: false,
          description: DESCRIPTIONS.WEIGHTTRAINING
        },
        {
          id: 17,
          specialityId: 6,
          title: 'Melhor idade',
          shift: false,
          selected: false,
          description: DESCRIPTIONS.BETTERAGE
        },
        {
          id: 18,
          specialityId: 6,
          title: 'Consultoria Esportiva',
          shift: false,
          selected: false,
          description: DESCRIPTIONS.SPORTCONSULTATION
        }
      ]
    }
  }
}

export default Profissionals
